import React from 'react';
import Game from '../Game/Game'

const App = () => {
  return (
    <div>
      <Game />
    </div>
  );
};

export default App;
